import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import history from './history';
import store, { persistor } from './store';
import Routes from './components/Routes';
import './utils/css/fonts.css';
import { GlobalStyle } from './theme';
import { setAxiosHeader } from './store/middleware/auth.middleware';
import { getAccessToken, hasValidTokens } from './utils/tokenUtils';
import './matrielUiStyles.css';
import ErrorBoundary from './components/common/ErrorBoundary/ErrorBoundary';
import { AccessibilityLanguageProvider } from './components/Admin/SalonTeaming/AccessibilityLanguageContext';

const App: React.FC = () => {
	useEffect(() => {
		if (hasValidTokens()) {
			const accessToken = getAccessToken();
			setAxiosHeader(accessToken!);
		} else {
			console.log('No valid tokens found on app initialization');
		}
	}, []);

	return (
		<ErrorBoundary>
			<AccessibilityLanguageProvider>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<GlobalStyle />
						<Router history={history}>
							<Routes />
						</Router>
					</PersistGate>
				</Provider>
			</AccessibilityLanguageProvider>
		</ErrorBoundary>
	);
};

export default App;
